/* LUMAVO interactions: scroll reveal, tilt cards, lazy WebGL hero. */
(function () {
  if (window.__lumavo) return; window.__lumavo = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.lmv-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initTilt(root) {
    if (reduce || !finePointer) return;
    (root || document).querySelectorAll('[data-lmv-tilt]').forEach(function (card) {
      if (card.__tilt) return; card.__tilt = true;
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        card.style.transform = 'rotateY(' + (x * 10) + 'deg) rotateX(' + (-y * 10) + 'deg)';
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  function canRun3D() {
    if (reduce) return false;
    var c = navigator.connection; if (c && (c.saveData || /2g/.test(c.effectiveType || ''))) return false;
    if (navigator.deviceMemory && navigator.deviceMemory < 3) return false;
    try { var cv = document.createElement('canvas'); return !!(cv.getContext('webgl2') || cv.getContext('webgl')); } catch (e) { return false; }
  }
  function loadThree(cb) {
    if (window.THREE) return cb();
    var s = document.createElement('script');
    s.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
    s.async = true; s.onload = cb; s.onerror = function () {}; document.head.appendChild(s);
  }
  function initHero(el) {
    if (el.__hero || !canRun3D()) return; el.__hero = true;
    var start = function () { loadThree(function () { buildScene(el); }); };
    if ('requestIdleCallback' in window) requestIdleCallback(start, { timeout: 1500 }); else setTimeout(start, 400);
  }
  function buildScene(el) {
    var T = window.THREE; if (!T) return;
    var accentA = new T.Color(el.dataset.accentA || '#8B7CFF'), accentB = new T.Color(el.dataset.accentB || '#5AA9FF');
    var renderer = new T.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'low-power' });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.5));
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.domElement.setAttribute('aria-hidden', 'true');
    el.insertBefore(renderer.domElement, el.firstChild);

    var scene = new T.Scene();
    var cam = new T.PerspectiveCamera(35, 1, .1, 100); cam.position.set(0, 0, 9);
    var rig = new T.Group(); scene.add(rig);

    var core = new T.Mesh(new T.SphereGeometry(.55, 48, 48), new T.MeshBasicMaterial({ color: 0xf4f1ea }));
    rig.add(core);
    var shell = new T.Mesh(new T.IcosahedronGeometry(1.45, 4), new T.MeshPhysicalMaterial({
      color: 0x1a1a24, roughness: .25, metalness: .1, transmission: .9, thickness: 1.2, transparent: true, opacity: .55, clearcoat: 1
    }));
    rig.add(shell);
    var ringMat = function (c) { return new T.MeshBasicMaterial({ color: c, transparent: true, opacity: .85 }); };
    var ring1 = new T.Mesh(new T.TorusGeometry(2.25, .012, 16, 220), ringMat(accentA));
    var ring2 = new T.Mesh(new T.TorusGeometry(2.7, .008, 16, 220), ringMat(accentB));
    ring1.rotation.x = 1.15; ring2.rotation.x = 1.35; ring2.rotation.y = .4; rig.add(ring1, ring2);
    var halo = new T.Mesh(new T.SphereGeometry(1.9, 32, 32), new T.MeshBasicMaterial({ color: accentA, transparent: true, opacity: .06, side: T.BackSide }));
    rig.add(halo);
    var n = 520, pos = new Float32Array(n * 3);
    for (var i = 0; i < n; i++) { var r = 3 + Math.random() * 5, a = Math.random() * 6.283, b = (Math.random() - .5) * 2.4;
      pos[i * 3] = Math.cos(a) * r; pos[i * 3 + 1] = b * 1.6; pos[i * 3 + 2] = Math.sin(a) * r - 2; }
    var dg = new T.BufferGeometry(); dg.setAttribute('position', new T.BufferAttribute(pos, 3));
    var dust = new T.Points(dg, new T.PointsMaterial({ color: 0xbfbaf5, size: .025, transparent: true, opacity: .7 }));
    scene.add(dust);
    scene.add(new T.AmbientLight(0x404050, .6));
    var l1 = new T.PointLight(accentA, 3, 20); l1.position.set(-3, 2, 3); scene.add(l1);
    var l2 = new T.PointLight(accentB, 3, 20); l2.position.set(3, -1, 2); scene.add(l2);
    var l3 = new T.PointLight(0xfff3e0, 2.2, 10); scene.add(l3);

    function layout() {
      var w = el.clientWidth, h = el.clientHeight; renderer.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix();
      var mobile = w < 750; rig.position.set(mobile ? .6 : 2.6, mobile ? 1.6 : 0, 0); rig.scale.setScalar(mobile ? .75 : 1);
    }
    layout(); window.addEventListener('resize', layout, { passive: true });

    var mx = 0, my = 0, tx = 0, ty = 0, scrollK = 0;
    window.addEventListener('pointermove', function (e) { tx = e.clientX / window.innerWidth - .5; ty = e.clientY / window.innerHeight - .5; }, { passive: true });
    window.addEventListener('scroll', function () { scrollK = Math.min(window.scrollY / (el.clientHeight || 1), 1); }, { passive: true });

    var visible = true, running = false, clock = new T.Clock();
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) loop(); }).observe(el);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) loop(); });
    function frame() {
      if (!visible || document.hidden) { running = false; return; }
      var t = clock.getElapsedTime();
      mx += (tx - mx) * .05; my += (ty - my) * .05;
      rig.rotation.y = t * .12 + mx * .6; rig.rotation.x = my * .4;
      ring1.rotation.z = t * .25; ring2.rotation.z = -t * .18;
      core.scale.setScalar(1 + Math.sin(t * 1.6) * .04);
      dust.rotation.y = t * .02 + mx * .15;
      cam.position.x = mx * .8; cam.position.y = -my * .5 - scrollK * 1.2; cam.lookAt(0, 0, 0);
      renderer.render(scene, cam); requestAnimationFrame(frame);
    }
    function loop() { if (!running) { running = true; requestAnimationFrame(frame); } }
    loop(); el.classList.add('is-3d');
  }

  function boot(root) {
    initReveal(root); initTilt(root);
    (root || document).querySelectorAll('[data-lmv-hero]').forEach(initHero);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
